module.exports = __webpack_public_path__ + "img/logo-large.1dc61089.png";